import projectJson from "../project.json";

export const projectName = projectJson.name;
